import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { CertificateModel } from '../../model/CertificateModel';
import { UserModel } from '../../model/UserModel';
import { getAllCertificates } from '../../services/certificateService';
import { getUserDetails } from '../../services/userService';
import { getUserData } from '../../services/utilityServices';
import { parseJwt } from '../../utils/generalUtils';
import { Async } from '../reusableComponents/Async';
import { BasePage } from '../reusableComponents/BasePage';
import { ListPage } from '../reusableComponents/ListPage';
import { Loader } from '../reusableComponents/Loader/Loader';
import { ListItem } from './ListItem';


export interface ICertificateListPageProps {
    instances: CertificateModel[];
    userInstance: UserModel;
    userUID: string;
}

export interface ICertificateListPageState {
    open: boolean;
}

export class CertificateListPageImpl extends React.PureComponent<ICertificateListPageProps, ICertificateListPageState> {
    constructor(props: ICertificateListPageProps) {
        super(props);
        this.state = { open: false };
    }

    public promise = async () => {
        const isAdmin = UserModel.isAdmin(this.props.userInstance);
        await getAllCertificates(isAdmin ? '' : this.props.userUID);
    }

    public renderModuleList = () => {
        const isAdmin = UserModel.isAdmin(this.props.userInstance);
        return <ListPage
            instances={this.props.instances}
            listItemComponent={ListItem}
            searchPlaceHolder="Enter username, category, module name to search..."
            searchBy={['', 'userName', 'moduleName', 'Category', 'DateCompleted']}
            pageHeadings={isAdmin ? ['#', 'User Name', 'Module Name', 'Category', 'Completed Date', 'Download'] : ['#', 'Module Name', 'Category', 'Completed Date', 'Download']}
            promise={this.promise}
            isSearchable={true}
            cols={isAdmin ? [1, 2, 2, 2, 3, 2] : [1, 3, 3, 3, 2]}
            emptyListMessage="No Certificate Available"
            chartTitle = "CertificateList"
        />;
    }

    public handleDeleteListItems = () => {
        this.setState({
            open: true
        });
    }

    public render() {
        return <BasePage className="certificate-list-page" title="Certificate List" icon="certificate">
            <Async
                identifier="CertificateListPage"
                promise={this.promise}
                loader={<Loader type="async" />}
                content={this.renderModuleList()}
                error={<Loader type="async" />}
            />
        </BasePage >;
    }
}
export function mapStateToProps(state) {
    const userUID = state.login.get('token') ? parseJwt(state.login.get('token')).UniqueID : getUserData().userUID;
    return {
        userUID,
        instances: CertificateModel.list(),
        userInstance: UserModel.get(userUID)
    };
}
export const CertificateListPage = 
withRouter(connect<{}, {}, ICertificateListPageProps>(mapStateToProps)(CertificateListPageImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CertificatePages/CertificateListPage.tsx